// using es modules
import device from 'current-device'

window.device = device
